module.exports = __webpack_public_path__ + "img/conceptanswer.ebe9a70f.png";